var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClothactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2",
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2",
    "data-name": "\\u56FE\\u5C42 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M905.41,251.21,808.62,192,707.84,130.35a16,16,0,0,0-8.35-2.35h-375a16,16,0,0,0-8.35,2.35L215.38,192l-96.79,59.21A16,16,0,0,0,112,264.15V553.8A16,16,0,0,0,133.06,569L256,528V888a8,8,0,0,0,8,8H760a8,8,0,0,0,8-8V528l122.94,41A16,16,0,0,0,912,553.8V264.15A16,16,0,0,0,905.41,251.21ZM576,528a32,32,0,0,0-32,32,96,96,0,0,1-96,96,32,32,0,0,1,0-64,32,32,0,0,0,32-32,96,96,0,0,1,96-96,32,32,0,0,1,0,64ZM512,352A160,160,0,0,1,352,192H672A160,160,0,0,1,512,352Z",
    style: {
      fill: "#006eff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    style: {
      fill: "none"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClothactive);
export default __webpack_public_path__ + "static/media/clothactive.9889e9cc96b4e2e487bb4a8ff5c418e2.svg";
export { ForwardRef as ReactComponent };